import { useCallback, useEffect, useState } from 'react';

const RECOVERY_URL_KEY = 'opendoor.cosmos.clientErrorRecoveryUrl';

export const shouldReloadAfterClientError = (
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  currentUrl: string,
): boolean => {
  if (storage.getItem(RECOVERY_URL_KEY) === currentUrl) {
    return false;
  }

  storage.setItem(RECOVERY_URL_KEY, currentUrl);
  return true;
};

export const clearClientErrorRecoveryAttempt = (storage: Pick<Storage, 'removeItem'>): void => {
  storage.removeItem(RECOVERY_URL_KEY);
};

export const ClientErrorRecovery = () => {
  const [showFallback, setShowFallback] = useState(false);

  const retry = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    try {
      if (shouldReloadAfterClientError(window.sessionStorage, window.location.href)) {
        window.location.reload();
        return;
      }
    } catch {
      // Without storage, an automatic reload could loop on a persistent error.
    }

    setShowFallback(true);
  }, []);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-subheader-lg">{showFallback ? 'Something went wrong' : 'Refreshing…'}</h1>
      {showFallback && (
        <button
          className="rounded-full bg-od-bg-accent-brand px-6 py-3 text-label-md text-od-content-inverse-primary"
          onClick={retry}
          type="button"
        >
          Try again
        </button>
      )}
    </main>
  );
};
